var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElrond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 300,
    viewBox: "0 0 300 300",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    height: 300,
    rx: 150,
    width: 300
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m158.482 149.928 70.232-37.399-11.795-22.529-64.344 25.854c-1.652.669-3.498.669-5.15 0l-64.3436-25.854-11.8314 22.602 70.232 37.398-70.232 37.398 11.8314 22.602 64.3436-26.052c1.652-.669 3.498-.669 5.15 0l64.344 25.926 11.831-22.602z",
    fill: "#23f7dd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElrond);
export default __webpack_public_path__ + "static/media/elrond.8fa1b971657d5e7d75ea070deabd300f.svg";
export { ForwardRef as ReactComponent };